import { render, staticRenderFns } from "./recommendBankList.vue?vue&type=template&id=3490cc98&scoped=true&"
import script from "./recommendBankList.vue?vue&type=script&lang=js&"
export * from "./recommendBankList.vue?vue&type=script&lang=js&"
import style0 from "./recommendBankList.vue?vue&type=style&index=0&id=3490cc98&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3490cc98",
  null
  
)

export default component.exports